// src/modules/moduleDashboards/components/actions/BranchPicker.jsx
// The in-card branch selector for branch-shaped widgets. Rendered only when the
// server sent options — branch-scoped viewers get none, because they cannot look
// at another branch and a disabled dropdown would only imply otherwise.
import React from 'react';
import { Select, Empty, Alert } from 'antd';
import { ShopOutlined } from '@ant-design/icons';

export function BranchPicker({ branches, value, onChange, loading, size = 'small', width = 190 }) {
  if (!branches || branches.length === 0) return null;
  return (
    <Select
      size={size}
      style={{ width }}
      value={value || undefined}
      onChange={onChange}
      loading={loading}
      placeholder="Select branch"
      showSearch
      optionFilterProp="label"
      suffixIcon={<ShopOutlined />}
      options={branches.map((b) => ({ value: b.id, label: b.name }))}
    />
  );
}

// Shown in place of the widget body when no branch is resolved yet.
export function NeedsBranch({ branches, value, onChange, loading, what }) {
  if (!branches || branches.length === 0) {
    return (
      <Alert
        type="info"
        showIcon
        message="No branch available"
        description={`${what} is per branch, and your account is not attached to one. Ask an administrator to set your branch, or pick a branch in the dashboard filter above.`}
      />
    );
  }
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={<span style={{ fontSize: 13 }}>{what} is per branch — choose one to begin</span>}
    >
      <BranchPicker branches={branches} value={value} onChange={onChange} loading={loading} size="middle" width={240} />
    </Empty>
  );
}

export default BranchPicker;
